module.exports = __webpack_public_path__ + "img/icon-giftbox.e850d6e7.svg";